// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2hZtr","question":"styles_question__2SQar","inputVisibleButton":"styles_inputVisibleButton__1c1PH","note":"styles_note__3OSsY"};